export default __webpack_public_path__ + "static/media/metabolic@2x.6ea48f97.jpg";